import { ChangeDetectorRef, Component, Input } from '@angular/core';

export type LoadingType = 'default' | 'atlas';

@Component({
    selector: 'mapp-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss'],
    standalone: false,
})
export class PreloaderComponent {
    @Input() loadingMessage: string;

    @Input() type: LoadingType = 'default';

    /**
     *
     */
    @Input() set isLoading(value: boolean) {
        this._loading = value ?? false;
    }

    protected _loading = true;

    /**
     *
     * @param cdr
     */
    constructor(private cdr: ChangeDetectorRef) {}

    /**
     *
     */
    load() {
        this._loading = true;
        this.cdr.detectChanges();
    }

    /**
     *
     */
    loaded() {
        this._loading = false;
        this.cdr.detectChanges();
    }

    /**
     *
     */
    get loading() {
        return this._loading;
    }
}
